import React, { FC } from 'react';
import styles from './ShowPartners.module.scss';
import { useStore } from '../../../../common';

const ShowPartners: FC = (): JSX.Element => {
	const [state] = useStore();
	const { selectedGameProvider } = state;
	const assignedPartners = selectedGameProvider?.gameProvider?.assigned_partners || [];

	return (
		<section>
			<div className={styles.ShowProviders}>
				<h2>Assigned Partners</h2>
				<div className={styles.TableScroll}>
					<table>
						<thead>
							<tr>
								<th>Partner ID</th>
								<th>Short Name Live</th>
								<th>Short Name Test</th>
								<th>Name</th>
							</tr>
						</thead>
						<tbody>
							{assignedPartners.map((assignedPartners: any) => (
								<tr key={assignedPartners.partner_id}>
									<td>{assignedPartners.partner_id}</td>
									<td>{assignedPartners.short_name_live}</td>
									<td>{assignedPartners.short_name_test}</td>
									<td>{assignedPartners.name}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</section>
	);
};

export { ShowPartners };
